// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { floatingTooltipStyles } from "@conklin/App/Components/FloatingTooltip/FloatingTooltip";
import { color, getSystemColor, styledScrollbar } from "@conklin/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipArrow = {
    width: 13,
    height: 13,
    fill: getSystemColor("common.white"),
    stroke: `${getSystemColor("common.border")}`,
    strokeWidth: 1,
};

floatingTooltipStyles.tooltipContent = {
    css: css`
        border: 1px solid ${color("common.ui5")};
        background-color: ${color("common.white")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        border-radius: 4px;
        min-width: 200px;
    `,
};

floatingTooltipStyles.drawerContent = {
    css: css`
        display: flex;
        position: fixed;
        flex-direction: column;
        background-color: ${color("common.white")};
        right: -400px;
        top: 0;
        height: 100vh;
        padding: 12px;
        width: 332px;
        z-index: ${getProp("theme.zIndex.drawer")};
        transition: right 0.5s ease-in-out;
        ${styledScrollbar(2)}
        ${({ isMounted }: any) =>
            isMounted &&
            css`
                right: 2px;
            `}
    `,
};

floatingTooltipStyles.drawerClose = {
    variant: "link" as any,
    css: css`
        margin: 0 0 8px auto;
        ${ButtonIcon} {
            color: ${color("common.ui7")};
        }
    `,
};
